import React from 'react';
import PropTypes from 'prop-types';
import { createHashHistory } from 'history';
import { Nav, NavItem, NavLink, Container, Row, Col, Card, CardBody } from 'reactstrap';
import { kebabCase, camelCase } from 'lodash';
import { hasAdminSubSectionPermission } from '../../../utils/paths';
const hashHistory = createHashHistory();
const EmployeeContainer = _ref => {
  let _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    section = _ref.section,
    id = _ref.id;
  const length = section.length;
  const handleSelect = key => hashHistory.replace("/admin/employees/".concat(id, "/").concat(key));
  const header = /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-ec-section-title"
  }, "Employee Sections")));
  const employeeInfoPermission = hasAdminSubSectionPermission('employees_info');
  const navItems = [];
  if (employeeInfoPermission) {
    navItems.push('General');
    navItems.push('Credentials');
    navItems.push('Jobs');
  }
  if (hasAdminSubSectionPermission('employees_certifications')) {
    navItems.push('Certifications');
  }
  if (hasAdminSubSectionPermission('employees_asset')) {
    navItems.push('Assets');
  }
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
    className: "card-heading"
  }, header), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
    pills: true,
    vertical: true
  }, navItems.map((item, index) => /*#__PURE__*/React.createElement(NavItem, {
    active: length > 0 ? camelCase(item) === section : index === 0,
    key: "nav-".concat(kebabCase(item)),
    className: "t-ec-nav-section-".concat(kebabCase(item))
  }, /*#__PURE__*/React.createElement(NavLink, {
    onClick: () => handleSelect(camelCase(item))
  }, item))))))), /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, children)));
};
EmployeeContainer.propTypes = {
  id: PropTypes.string.isRequired,
  section: PropTypes.string.isRequired,
  children: PropTypes.node
};
export default EmployeeContainer;